import classNames from 'classnames'

type Props = {
  label1: string
  label2?: string
  className?: string
  label1ClassName?: string
  label2ClassName?: string
}

const baseClasses =
  'w-max rounded-[100px] border-1 border-arcadeGreen shadow-arcade-md body-lg px-[14px] py-1'

const ArcadeShadowBadge = ({
  label1,
  label2,
  className,
  label1ClassName,
  label2ClassName
}: Props) => {
  return (
    <div className={classNames(baseClasses, className)}>
      <span
        className={classNames('text-arcadeGreen mr-[4px]', label1ClassName)}
      >
        {label1}
      </span>
      {label2 && (
        <span
          className={classNames('text-white font-extrabold', label2ClassName)}
        >
          {label2}
        </span>
      )}
    </div>
  )
}

export default ArcadeShadowBadge
